import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// Employee Laundry Benefit report — reads the read-only Store WebAPI proc for
// per-employee ₹1,000/month personal-laundry allowance usage, and a one-click
// credit action. Same token-refresh pattern as crmcampaignservice / rto3service.
export default class EmpLaundryBenefitService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getReport(month, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_EMP_LAUNDRY_BENEFIT_REPORT });
    let out = {};
    await api.endpoints[this.endpoint.GET_EMP_LAUNDRY_BENEFIT_REPORT]
      .getAllPost({ Month: month || "" })
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getReport(month, true);
        return out;
      } catch (e) {
        return { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return out && out.data !== undefined ? out.data : out;
  }

  async creditMonth(isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.CREDIT_EMP_LAUNDRY_BENEFIT });
    let out = {};
    await api.endpoints[this.endpoint.CREDIT_EMP_LAUNDRY_BENEFIT]
      .getAllPost({})
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.creditMonth(true);
        return out;
      } catch (e) {
        return { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    return out && out.data !== undefined ? out.data : out;
  }
}
